import { indexData } from '@/mocks/home';

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <h2 className="font-heading font-bold text-2xl md:text-4xl text-foreground-950 mb-3">内容索引</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            按分类快速找到你感兴趣的娱乐八卦内容
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5 max-w-5xl mx-auto">
          {indexData.map((item) => (
            <a
              key={item.id}
              href={`#index`}
              className="group flex flex-col items-center text-center p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/70 hover:border-primary-300 hover:bg-background-50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-2xl bg-primary-100 flex items-center justify-center mb-3 group-hover:bg-primary-500 transition-colors">
                <i className={`${item.icon} text-xl md:text-2xl text-primary-600 group-hover:text-background-50 transition-colors`}></i>
              </div>
              <h3 className="font-semibold text-sm md:text-base text-foreground-900 mb-1">{item.title}</h3>
              <span className="text-xs text-foreground-500 mb-1">{item.count}</span>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}